import { AxiosInstance } from 'axios';
import { TopicInsidesRepository } from '@/model/repository/manager/topicInsides/TopicInsidesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): TopicInsidesRepository => ({
    index(payload) {
      return Repository.get(`/api/v3/admin/topic_insides`, { params: payload });
    },
    store(payload) {
      return Repository.post(`${resource}`, payload);
    },
    update(id, payload) {
      return Repository.put(`${resource}/${id}`, payload);
    },
    delete(id) {
      return Repository.delete(`${resource}/${id}`);
    },
  });
